import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

export const crmPermissions = {
  view: "crm.view",
  viewSwitch: "crm.viewSwitch.use",
  assignee: { view: "crm.assignee.view", update: "crm.assignee.update" },
  restaurantConvert: "crm.restaurant.convert",
  delete: "crm.delete",
};

export const crmGrants = {
  // dmm opens the page (NA-014); its extra actions stay the ones listed below.
  "crm.view": rule(lud(R.AM, R.SALES, R.DMM)),
  "crm.viewSwitch.use": rule(lud(R.DMM)),
  "crm.assignee.view": rule(lud(R.DMM)),
  "crm.assignee.update": rule(lud(R.DMM)),
  "crm.restaurant.convert": rule(lud(R.DMM)),
  "crm.delete": rule(lud()),
};
